import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {TranslateLoader} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';

export class MyTranslateHttpLoader implements TranslateLoader {
    constructor(private http: HttpClient) {
    }

    /**
     * Gets the translations from the server
     */
    public getTranslation(lang: string): Observable<object> {
        const headers = new HttpHeaders().set('X-Api-Version', environment.appApiVersion.toString(10));
        const params = new HttpParams().set('lang', lang);
        return this.http.get(environment.appApiUrl + 'getTranslation', {headers, params})
            .pipe(
            map(data => {
                if (!!(data as any).result) {
                    return (data as any).result;
                } else {
                    return {};
                }
            })
        );
    }
}

export function createTranslateLoader(http: HttpClient) {
    return new MyTranslateHttpLoader(http);
}
